module.exports = __webpack_public_path__ + "img/result_qr_text.667a6298.png";